/**
 * casestudy
 */
'use strict';
import AppCase from '@/_modules/app_case';

document.addEventListener('DOMContentLoaded', () => {
  new AppCase();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});
